import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesCategoriesMain } from './modules/ui/Main';

const CategoriesPage = (
  <SuspensePage>
    <PagesCategoriesMain />
  </SuspensePage>
);

export default CategoriesPage;
